import { render } from "./Land.vue?vue&type=template&id=67cb74b1&scoped=true"
const script = {}

import "./Land.vue?vue&type=style&index=0&id=67cb74b1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67cb74b1"

export default script